<template>
  <div
    v-if="rollup_metrics.length"
    class="w-full py-2 top-0 transition ease-in-out duration-side-menu-transition-duration bg-light-screen-background dark:bg-dark-screen-background">
    <div class="flex flex-wrap gap-3 rounded-lg overflow-visible items-stretch">
      <TransitionGroup name="move">
        <div v-for="metric in rollup_metrics" :key="metric.id + metric.value" class="rounded-lg overflow-visible">
          <RollUpMetric :metric="metric" />
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script>
import dataService from "@/services/data.service"
import { VIEW_TYPES } from "@/store/constants/references"
import { utils } from "@/store/helpers"
import RollUpMetric from "./RollUpMetric.vue"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    RollUpMetric
  },
  inject: ["getViewMetrics"],
  props: {
    pageReference: {
      type: String,
      required: true
    },
    currentForecastName: {
      type: String,
      required: false
    },
    selectedObject: {
      type: String,
      required: false
    },
    selectedForecast: {
      type: String,
      default: null,
      required: false
    },
    selectedRecords: {
      type: Array,
      default: () => [],
      required: false
    },
    selectedGroup: {
      type: String,
      default: null,
      required: false
    },

    currentFilter: {
      type: String,
      default: "",
      required: false
    },
    selectedOwners: {
      type: Array,
      default: null
    },
    selectedDateRange: {
      type: Object,
      default: null
    },
    updateTrigger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page_reference: null,
      // old_rollups: [],
      rollup_metrics: [],
      initial_rollup_metrics_copy: [],
      page_rollups: []
    }
  },

  watch: {
    async selectedRecords(newValue, oldValue) {
      await this.getRollupMetricsIfFilterChanged(newValue, oldValue)
    },
    async selectedGroup(newValue, oldValue) {
      await this.getRollupMetricsIfFilterChanged(newValue, oldValue)
    },
    async currentFilter(newValue, oldValue) {
      await this.getRollupMetricsIfFilterChanged(newValue, oldValue)
    },
    async selectedOwners(newValue, oldValue) {
      await this.getRollupMetricsIfFilterChanged(newValue, oldValue)
    },
    async selectedDateRange(newValue, oldValue) {
      await this.getRollupMetricsIfFilterChanged(newValue, oldValue)
    },
    async updateTrigger() {
      await this.getRollupMetrics()
    },
    async page_rollups() {
      // this.resetRollups()
      await this.getRollupMetrics()
    },
    rollup_metrics: {
      deep: true,
      handler() {
        this.rollup_metrics.forEach((metric) => {
          this.$emitter.emit(ALL_EMITTERS.REFRESH_ROLLUP_METRIC, { metric: metric })
        })
      }
    }
  },
  async created() {
    this.register_listeners()
    this.getPageRolllups()

    await this.getRollupMetrics()
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_ROLLUP_METRICS_GRID, () => {
        this.getPageRolllups()
      })
      this.$emitter.on(ALL_EMITTERS.ROLLUP_METRICS_UPDATE, () => {
        this.getRollupMetrics()
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_ROLLUP_METRICS_GRID)
      this.$emitter.off(ALL_EMITTERS.ROLLUP_METRICS_UPDATE)
    },

    getPageRolllups() {
      if (this.pageReference == "opportunity_profile") {
        this.page_rollups = this.getViewMetrics({
          page_reference: "object_profile",
          object_type: this.selectedObject,
          view_type: VIEW_TYPES.ROLLUPS,
          flat: false
        })
      } else {
        this.page_rollups = this.getViewMetrics({
          page_reference: this.pageReference,
          object_type: this.selectedObject,
          view_type: VIEW_TYPES.ROLLUPS,
          current_forecast_name: this.currentForecastName,
          flat: false
        })
      }
    },
    // resetRollups() {
    //   if (this.old_rollups.length > this.page_rollups.length) {
    //     let to_be_removed_ids = this.old_rollups.map(x=>x.id).filter(id=>!this.page_rollups.map(d=>d.id).includes(id) )
    //     to_be_removed_ids.forEach((id)=>utils.removeItem(this.rollup_metrics,id))
    //     this.old_rollups = utils.clone(this.rollup_metrics)
    //   } else if (this.old_rollups.length == this.page_rollups.length) {
    //     if (utils.isEqual(this.old_rollups, this.page_rollups)) {
    //       let order_mapper = new Map(this.page_rollups.map((o) => [o.reference_name, null]))
    //       this.rollup_metrics.forEach((g) => order_mapper.set(g.reference_name, g))
    //       this.rollup_metrics = Array.from(order_mapper.values())
    //       this.old_rollups = utils.clone(this.rollup_metrics)
    //     } else {
    //       this.rollup_metrics = []
    //       let new_rollups = this.page_rollups
    //       this.refetchRollups(new_rollups)
    //     }
    //   } else {
    //     let new_rollups = this.page_rollups.filter((g) => this.old_rollups.findIndex((x) => x.id == g.id) == -1)
    //     this.refetchRollups(new_rollups)
    //   }
    // },
    // refetchRollups(new_rollups) {

    //   let order_mapper = new Map(this.page_rollups.map((o) => [o.id, this.rollup_metrics.find(x=>x.id==o.id)]))
    //   dataService.getRollupMetrics({ page_reference: this.pageReference, records: this.selectedRecords,target_metrics:new_rollups.map((x)=>x.id), groups: this.selectedGroup ? [this.selectedGroup.id] : [], owners: this.selectedOwners, from_date: this.selectedDateRange?.from_date, to_date: this.selectedDateRange?.to_date, records_filter: this.currentFilter }).then((res)=>{
    //     res.data.forEach((m)=>{
    //       utils.replaceOrAddItem(this.rollup_metrics, m, "reference_name")
    //         order_mapper.set(res.id, m)
    //     })
    //   })
    //   this.rollup_metrics = Array.from(order_mapper.values())
    //   this.old_rollups = utils.clone(this.rollup_metrics)

    // },
    async getRollupMetrics() {
      if (this.pageReference == "opportunity_profile") {
        this.page_reference = "object_profile"
      } else {
        this.page_reference = this.pageReference
      }
      let page
      if (this.currentForecastName) {
        page = `${this.page_reference}>${VIEW_TYPES.ROLLUPS}>${this.selectedObject}>${this.currentForecastName}`
      } else {
        page = `${this.page_reference}>${VIEW_TYPES.ROLLUPS}>${this.selectedObject}`
      }
      await dataService
        .getRollupMetrics({
          page_reference: page,
          records: this.selectedRecords,
          selected_forecast: this.selectedForecast,
          groups: this.selectedGroup ? [this.selectedGroup.id] : [],
          owners: this.selectedOwners,
          from_date: this.selectedDateRange?.from_date,
          to_date: this.selectedDateRange?.to_date,
          records_filter: this.currentFilter
        })
        .then((data) => {
          this.rollup_metrics = data.data

          if (
            utils.isEmpty(this.selectedRecords) &&
            utils.isEmpty(this.selectedGroup) &&
            utils.isEmpty(this.currentFilter) &&
            utils.isEmpty(this.selectedOwners)
          ) {
            this.initial_rollup_metrics_copy = data.data
          }
        })
    },
    async getRollupMetricsIfFilterChanged(newValue, oldValue) {
      if (utils.isNotEmpty(oldValue) && utils.isEmpty(newValue)) {
        this.rollup_metrics = this.initial_rollup_metrics_copy
      } else {
        await this.getRollupMetrics()
      }
    }
  }
}
</script>
